import { validateSalesDocumentFile } from './salesDocumentFiles';

export const validateSalesPartyDocumentFile = (file, t) => {
  return validateSalesDocumentFile(file, {
    extensions: ['pdf', 'doc', 'docx'],
    formatError: t('SALES_PARTIES.DOCUMENTS.FORMAT_ERROR'),
    mimeTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
    sizeError: t('SALES_PARTIES.DOCUMENTS.SIZE_ERROR'),
  });
};

export { uploadSalesDocumentFiles as uploadSalesPartyDocumentFiles } from './salesDocumentFiles';
